var _defs, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron8 = function SvgChevron8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147.32,
    height: 46,
    preserveAspectRatio: "none",
    viewBox: "-1 -1 151.315 50"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron8_svg__a",
    d: "m135.21 0 12.11 23-12.11 23H0l12.11-23L0 0z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron8_svg__a",
    fill: "#A6C5E0"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron8_svg__a",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 0
  })));
};
export default SvgChevron8;